import Vue from 'vue';
import {Prop} from 'vue-property-decorator';
import Component from 'vue-class-component';

@Component({})
class EdProgressLinear extends Vue {
    @Prop({type: String, default: '--ed-color-green'}) colorVariable!: string;
    @Prop({type: String, default: '4px'}) height!: string;
    @Prop({ type: Number, default: null }) progressWidthValue!: number | null;

    private readonly transparencyLevel: string = '40';

    get progressWidth(): string {
        return this.progressWidthValue ? `${this.progressWidthValue}%` : '';
    }

    get customStyles(): Record<string, string> {
        const colorValue = this.getCssVariableValue(this.colorVariable);

        return {
            '--progress-color': colorValue,
            '--progress-color-background': `${colorValue}${this.transparencyLevel}`,
            '--progress-height': this.height,
        };
    }

    getCssVariableValue(variableName: string, element: HTMLElement = document.documentElement): string {
        const match = variableName.match(/^var\((--[\w-]+)\)$/);
        const variable = match ? match[1] : variableName;

        return getComputedStyle(element).getPropertyValue(variable).trim();
    }
}

export default Vue.component('ed-progress-linear', EdProgressLinear);
